export const DailyNoAttendanceStudentsTableHeader = () => {
  return [
    { field: 'sl_no', headerName: 'Sl No', width: 90 },
    { field: 'admn_no', headerName: 'Admission No', width: 160, sortable: true },
    { field: 'course_enrollment_id', headerName: 'Course Enrollment No', width: 230, sortable: false },
    { field: 'course_enrollment_date', headerName: 'Course Enrollment Date', width: 250, sortable: true },
    { field: 'student_name', headerName: 'Student Name', width: 200, sortable: true,toolTipGetter:true},
    { field: 'class', headerName: 'Class', width: 150, sortable: true },
    { field: 'course_name', headerName: 'Course Name', width: 250, sortable: true,toolTipGetter:false},
    { field: 'phone', headerName: 'Contact No', width: 150, sortable: false },
    { field: 'sro_name', headerName: 'OGA Name', width: 180, sortable: false },
    { field: 'sro_remarks', headerName: 'OGA Remarks', width: 200, sortable: false },
    { field: 'cro_name', headerName: 'CRO Name', width: 180, sortable: false },
    { field: 'completed_sessions', headerName: 'Completed Sessions', width: 200, sortable: true },
    { field: 'last_session_date', headerName: 'Last Session Date', width: 200, sortable: true },
  ];
};
